import { http } from '@/utils'

export const employeeSelectorApi = (data: any): any =>
  http.post(`/selector/`, { selector_code: 'employee', ...data })

export const getemployeeApi = (data: any): any => http.post(`/hrm/simple/employees`, data)
